<template>
    <div>
        <div class="flex flex-row">
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-9rem">
                    <div>length</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Период вычисления средней линии, в тиках таймфрейма. Большее значение - более плавная кривая.'"></i></div>
                </div>
                <InputText type="text" v-model="value.length" class="w-4rem p-1 mb-1" />
            </div>
        </div>

        <div class="flex flex-row">
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-9rem">
                    <div>algorithm</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Метод определения тренда. value - направление линии среднего изменения цены. speed - скорость изменения (угол наклона) среднего изменения цены'"></i></div>
                </div>
                <Dropdown v-model="value.algorithm" :options="['value','speed']" placeholder="" />
            </div>
        </div>

        <div class="flex flex-row" v-if="value.algorithm === 'speed'">
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-9rem">
                    <div>speedToDown</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Скорость изменения средней (угол наклона), при котором считается, что начался нисходящий тренд. Чем ближе число к 0 тем быстрее будет признано, что тренд начался.'"></i></div>
                </div>
                <InputText type="text" v-model="value.speedToDown" class="w-5rem p-1 mb-1" />
            </div>
            <div class="flex flex-row align-items-center mb-2">
                <div class="flex flex-row w-8rem">
                    <div>speedToUp</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Скорость изменения средней (угол наклона), при котором считается, что начался восходящий тренд. Чем ближе число к 0 тем быстрее будет признано, что тренд начался.'"></i></div>
                </div>
                <InputText type="text" v-model="value.speedToUp" class="w-5rem p-1 mb-1" />
            </div>
        </div>

        <div class="flex flex-row" v-if="value.algorithm === 'value'">
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-9rem">
                    <div>timeGapDown</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Время после начала падения средней, после которого считается, что начался нисходящий тренд.'"></i></div>
                </div>
                <InputText type="text" v-model="value.timeGapDown" class="w-4rem p-1 mb-1" />
            </div>
            <div class="flex flex-row align-items-center mb-2">
                <div class="flex flex-row w-9rem">
                    <div>timeGapUp</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Время после начала роста средней, после которого считается, что начался нисходящий тренд.'"></i></div>
                </div>
                <InputText type="text" v-model="value.timeGapUp" class="w-4rem p-1 mb-1" />
            </div>
        </div>

        <div class="flex flex-row">
            <div class="flex flex-row align-items-center mb-2 mr-4">
                <div class="flex flex-row w-9rem">
                    <div>maxTailDown</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Если больше 0 - нисходящий тренд будет считаться продолжающимся, даже если его признаки окончились. Длиться он будет такое же количество баров, но не более чем maxTailDown.  0 - отключение этой фичи.'"></i></div>
                </div>
                <InputText type="text" v-model="value.maxTailDown" class="w-4rem p-1 mb-1" />
            </div>
            <div class="flex flex-row align-items-center mb-2">
                <div class="flex flex-row w-9rem">
                    <div>maxTailUp</div>
                    <div class="ml-1 text-gray-500 cursor-pointer">
                        <i class="pi pi-question-circle"
                           v-tooltip.bottom="'Если больше 0 - восходящий тренд будет считаться продолжающимся, даже если его признаки окончились. Длиться он будет такое же количество баров, но не более чем maxTailDown. 0 - отключение этой фичи.'"></i></div>
                </div>
                <InputText type="text" v-model="value.maxTailUp" class="w-4rem p-1 mb-1" />
            </div>
        </div>



    </div>
</template>

<script>
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";

export default {
    components: {InputText, Dropdown},
    props:{
        value: Object,
    },
    data(){
        return {

        }
    },
    mounted(){
        this.form = this.value;
    },
}
</script>
